import { Injectable } from '@angular/core';

import { CreditosService } from '../../../../modules/finanzas/creditos/creditos.service';
import { CreditosModel } from '../../../../modules/finanzas/creditos/creditos.model';
import { ensureOk } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class CreditEntityService {

  constructor(private creditosService: CreditosService) { }

  get(uid: string): Promise<CreditosModel> {
    return this.creditosService.get(uid).then(credit => {
      if (!credit) throw new Error();
      return credit;
    });
  }

  create(payload: CreditosModel): Promise<void> {
    return this.creditosService.add(payload).then(ensureOk);
  }

  update(uid: string, payload: CreditosModel): Promise<void> {
    return this.creditosService.edit({ ...payload, uid }).then(ensureOk);
  }
}
